// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7HzsF","label":"styles_label__3FZ8T"};